module.exports = __webpack_public_path__ + "img/snav_icon_5.77470c91.png";